import { render, staticRenderFns } from "./snackComp.vue?vue&type=template&id=042b8e8c&scoped=true"
import script from "./snackComp.vue?vue&type=script&lang=js"
export * from "./snackComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b8e8c",
  null
  
)

export default component.exports